import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-screen-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "px-3 py-4 font-light font-roboto text-blue-800 text-2xl" }, "Seadme lisamine", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicXrayEquipmentForm = _resolveComponent("ClinicXrayEquipmentForm")!
  const _component_ModalWrapper = _resolveComponent("ModalWrapper")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-wrapper" }, [
    _createVNode(_component_ModalWrapper, {
      open: _ctx.isOpen,
      onOnclose: _cache[1] || (_cache[1] = () => _ctx.$emit('onClose'))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_ClinicXrayEquipmentForm, {
            onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = false)),
            onOnXrayEquipment: _ctx.onXrayEquipment,
            "clinic-u-i-d": _ctx.activeClinicUID
          }, null, 8, ["onOnXrayEquipment", "clinic-u-i-d"])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}